import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";
import AppIcon from "../components/AppIcon";
import SchoolBrand from "../components/SchoolBrand";
import "../styles/dashboard.css";

const InfoRow = ({ label, value }) => (
  <div className="profile-row">
    <strong>{label}</strong>
    <span>{value || "NA"}</span>
  </div>
);

const StudentProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [student, setStudent] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    if (!token || !["admin", "superadmin"].includes(role || "")) {
      navigate("/login");
      return;
    }

    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await api.get(`/admin/students/${id}`);
        setStudent(res.data.student || null);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load student profile");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, navigate]);

  if (loading) return <div className="dash-root"><p>Loading student profile...</p></div>;

  return (
    <div className="dash-root">
      <aside className="dash-sidebar">
        <SchoolBrand />
        <div className="dash-sidebar-inner">
          <h2 className="dash-title">Student Profile</h2>
          <p className="dash-subtitle">{student?.name || "Student"}</p>
          <button className="dash-nav-btn" onClick={() => navigate("/admin/dashboard")}>
            Back To Admin
          </button>
        </div>
      </aside>

      <section className="dash-main">
        <header className="dash-topbar">
          <h1 className="dash-top-title">Student Profile</h1>
          <span className="dash-top-user">{student?.name || "Student"}</span>
        </header>

        <main className="dash-content">
          <p className="dash-breadcrumb">Home - Student Details</p>
          {error && <p className="dash-error">{error}</p>}
          {!student && !error && <p>Student not found.</p>}
          {student && (
            <section>
              <div className="profile-header-row" style={{ marginBottom: 12 }}>
                {student.photoUrl ? (
                  <img src={student.photoUrl} alt={student.name} className="profile-avatar" />
                ) : (
                  <div className="profile-avatar placeholder"><AppIcon name="child" size={24} /></div>
                )}
                <h1 style={{ margin: 0 }}>{student.name}</h1>
              </div>
              <div className="profile-grid">
                <div className="dash-panel">
                  <h3>Student Details</h3>
                  <InfoRow label="Class" value={`${student.class || "NA"}-${student.section || "NA"}`} />
                  <InfoRow label="Roll Number" value={student.rollNo} />
                  <InfoRow label="Admission Number" value={student.admissionNo} />
                  <InfoRow label="Academic Year" value={student.academicYear} />
                  <InfoRow label="Date of Birth" value={student.dateOfBirth ? new Date(student.dateOfBirth).toLocaleDateString() : ""} />
                  <InfoRow label="Gender" value={student.gender} />
                  <InfoRow label="Blood Group" value={student.bloodGroup} />
                  <InfoRow label="Emergency Contact Name" value={student.emergencyContactName} />
                  <InfoRow label="Emergency Contact Phone" value={student.emergencyContactPhone} />
                  <InfoRow label="Notes" value={student.notes} />
                </div>

                <div className="dash-panel">
                  <h3>Address</h3>
                  <InfoRow label="Address" value={student.address} />
                  <InfoRow label="City" value={student.city} />
                  <InfoRow label="State" value={student.state} />
                  <InfoRow label="Country" value={student.country} />
                  <InfoRow label="Pincode" value={student.pincode} />
                </div>

                <div className="dash-panel">
                  <h3>Parent Details</h3>
                  <InfoRow label="Parent Name" value={student.parent?.name} />
                  <InfoRow label="Parent Email" value={student.parent?.email} />
                  <InfoRow label="Parent Phone" value={student.parent?.phone} />
                  <InfoRow label="Parent Address" value={student.parent?.address} />
                  <InfoRow label="Parent Role" value={student.parent?.role} />
                </div>
              </div>
            </section>
          )}
        </main>
      </section>
    </div>
  );
};

export default StudentProfile;
